import { useEffect, useState } from "react"

import { useAppSelector } from "../../hooks/use-app-selector.ts"
import { selectActiveBranchId } from "../Branches/redux/branches.slice.ts"
import { getInactiveCounts } from "../Leads/api/services.ts"
import { getProjects } from "../Projects/api/services.ts"

interface ArchiveTabTotals {
  leads?: number
  projects?: number
}

/**
 * Each tab's own screen only fetches once it is opened, so the tab not shown
 * first had no count until it was clicked. Both totals are read here when the
 * page opens, scoped to the active branch the way each screen scopes its own
 * list; a total the request could not read stays absent rather than `0`.
 */
export function useArchiveTabTotals(enabled: boolean): ArchiveTabTotals {
  const activeBranchId = useAppSelector(selectActiveBranchId)
  const [totals, setTotals] = useState<ArchiveTabTotals>({})

  useEffect(() => {
    if (!enabled) return
    let current = true
    const team = activeBranchId ? { team: activeBranchId } : {}
    setTotals({})

    getInactiveCounts(team).then((response) => {
      if (!current || !response.ok) return
      const total = response.data?.total
      if (typeof total === "number") {
        setTotals((prev) => ({ ...prev, leads: total }))
      }
    })
    getProjects({ view: "archive", page_size: 1, page: 1, ...team }).then(
      (response) => {
        if (!current || !response.ok) return
        const count = response.data?.count
        if (typeof count === "number") {
          setTotals((prev) => ({ ...prev, projects: count }))
        }
      }
    )

    return () => {
      current = false
    }
  }, [enabled, activeBranchId])

  return totals
}
